import { render, staticRenderFns } from "./ChatExpert.vue?vue&type=template&id=9e473280&"
import script from "./ChatExpert.vue?vue&type=script&lang=js&"
export * from "./ChatExpert.vue?vue&type=script&lang=js&"
import style0 from "./ChatExpert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports